import request from '@/utils/request'
import { authUtil } from '@/utils/auth'
import { clearSession } from '@/utils/token-handler'

const getBaseURL = () => {
  const isDebug = import.meta.env.VITE_IS_DEBUG === 'true'
  if (isDebug) {
    return import.meta.env.VITE_API_DEBUG_URL
  }
  return import.meta.env.VITE_API_BASE_URL
}

export function getSwiperImages(tenantId, expiresInSeconds = 900) {
  return request({
    url: `/api/admin/Swiper`,
    method: 'get',
    params: { expiresInSeconds }
  })
}

export function getSwiperImage(tenantId, id, expiresInSeconds = 900) {
  return request({
    url: `/api/admin/Swiper/${id}`,
    method: 'get',
    params: { expiresInSeconds }
  })
}

export async function uploadSwiperImage(tenantId, data) {
  const token = authUtil.getToken()
  const baseURL = getBaseURL()
  
  const formData = new FormData()
  formData.append('file', data.file)
  
  const metadata = JSON.stringify({
    FileName: data.fileName || '',
    DisplayName: data.displayName || '',
    DisplayOrder: data.displayOrder || 0
  })
  
  formData.append('metadata', metadata)
  
  try {
    const headers = {}
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
    
    const response = await fetch(`${baseURL}/api/admin/Swiper`, {
      method: 'POST',
      headers,
      body: formData
    })
    
    if (!response.ok) {
      const errorText = await response.text()
      console.error('Upload error response:', errorText)
      throw new Error(errorText)
    }
    
    const result = await response.json()
    
    if (result.Success === false && result.Message === 'TOKEN_MISSING') {
      clearSession()
      window.location.href = '/login'
      throw new Error('Session expired')
    }
    
    return result
  } catch (error) {
    console.error('Upload failed:', error)
    throw error
  }
}

export function updateSwiperImage(tenantId, id, data) {
  return request({
    url: `/api/admin/Swiper/${id}`,
    method: 'put',
    data
  })
}

export function deleteSwiperImage(tenantId, id) {
  return request({
    url: `/api/admin/Swiper/${id}`,
    method: 'delete'
  })
}

export function reorderSwiperImages(tenantId, orders) {
  return request({
    url: `/api/admin/Swiper/reorder`,
    method: 'put',
    data: orders
  })
}

export function getHorseImages(tenantId, expiresInSeconds = 900) {
  return request({
    url: `/api/YolalImage/${tenantId}/horses`,
    method: 'get',
    params: { expiresInSeconds }
  })
}

export function getCoachImages(tenantId, expiresInSeconds = 900) {
  return request({
    url: `/api/YolalImage/${tenantId}/coaches`,
    method: 'get',
    params: { expiresInSeconds }
  })
}

export function uploadImage(tenantId, folderType, file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: `/api/YolalImage/${tenantId}/${folderType}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function deleteImage(tenantId, folderType, fileName) {
  return request({
    url: `/api/admin/images/${folderType}/${fileName}`,
    method: 'delete'
  })
}

// Get image by folder type and file name
export function getImage(folderType, fileName) {
  return request({
    url: `/api/admin/images/${folderType}/${fileName}`,
    method: 'get'
  })
}

// Update image metadata
export function updateImage(folderType, fileName, data) {
  return request({
    url: `/api/admin/images/${folderType}/${fileName}`,
    method: 'put',
    data
  })
}
